import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [devResetUrl, setDevResetUrl] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setMessage('');
    setDevResetUrl('');
    try {
      const { data } = await api.post('/auth/forgot-password', { email });
      setMessage(data.message || 'If that email exists, password reset instructions will be sent.');
      if (data.devResetUrl) setDevResetUrl(data.devResetUrl);
    } catch (_error) {
      setMessage('If that email exists, password reset instructions will be sent.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white p-8 shadow-xl">
        <h1 className="text-2xl font-bold text-slate-900">Reset Password</h1>
        <p className="mt-2 text-sm text-slate-600">Enter your email. We will send reset instructions if an account exists.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder="doctor@clinic.com" className="w-full rounded-2xl border border-slate-300 px-4 py-3 outline-none focus:border-indigo-500" required />
          <button disabled={loading} className="w-full rounded-2xl bg-indigo-600 px-4 py-3 font-semibold text-white disabled:opacity-60">
            {loading ? 'Sending...' : 'Send reset instructions'}
          </button>
        </form>
        {message ? <div className="mt-4 rounded-2xl bg-emerald-50 p-3 text-sm text-emerald-700">{message}</div> : null}
        {devResetUrl ? <div className="mt-3 break-all rounded-2xl bg-amber-50 p-3 text-xs text-amber-800">Development reset link: {devResetUrl}</div> : null}
        <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-indigo-700">Back to login</Link>
      </div>
    </div>
  );
}
